import Styled from 'styled-components'
import { maxQuery } from '../../../helpers'

export default Styled.div`
div.input--group {
    display: flex;
    max-width: 70%;
    ${maxQuery('lg')} {
        width: 95%;
        max-width: 500px;
    }
    input {
        border-radius: 5px 0px 0px 5px;
    }
    button {
background: rgb(255,123,13);
        border-radius: 0px 5px 5px 0px;
        border: none;
    }
}

input.field{
    width:150px;
    margin-right:20px;
}
div.JumbotronTitle{
    font-family: Poppins;
    font-style: SemiBold;
    font-size: 30px;
    line-height: 48px;
    line-height: 160%;
    margin-bottom:32px;
    color:rgba(255, 255, 255, 0.85);
}
div.JumbotronTitleContainer{
    margin-top:99px;
}
div.JumbotronBox{
    max-width:1201px;
    border: 1px Solid rgba(255, 255, 255, 0.2);
    height:auto;
    border-radious:12px;
    padding:30px;

}
div.JumbotronBoxContainer{
    margin-bottom:20px;
    display:flex;
}

div.JumbotronBoxImageTitle{
    font-family: poppins;
    font-style: regular;
    font-size: 16px;
    line-height: 26px;
    line-height: 160%;
    color:#ffffff;
   flex:1;
}
div.JumbotronBoxImageetails{
    font-family: Poppins;
    font-style: Regular;
    Font-size: 16px;
    line-height: 26px;
}
div.JumbotronBoxImage{
    display:flex;
    flex-direction:column;
    margin-left:10px;
    flex:1;
}
img {
    margin:0px;
    height:60px;
}
`